import { InformationLayout, TAppInformation } from "layouts";

const TERMS_AND_CONDITIONS: TAppInformation[] = [];

function TermsAndConditionsPage() {
  return <InformationLayout data={TERMS_AND_CONDITIONS} title="利用規約" />;
}

export { TermsAndConditionsPage };
